import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import isPlainObject from 'lodash/isPlainObject';

function mapToObject(aMap) {
  var obj = {};

  if (isPlainObject(aMap)) {
    obj = _objectSpread2({}, aMap);
  }

  if (typeof aMap.forEach === 'function') {
    aMap.forEach(function (v, k) {
      obj[k] = v;
    });
  }

  return obj;
}

export default mapToObject;
//# sourceMappingURL=mapToObject.js.map
